import { css } from '@mui/material';

export const useStyles = () => {
  return {
    pickerContainer: css`
      display: flex;
      flex-direction: column;
      gap: 5px;
    `,

    pickerBtn: css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      padding: 10px 16px;
      border: 1px solid #dddddd;
      background: white;
      border-radius: 100px;
      font-weight: 400;
      font-size: 15px;
    `,

    datePickerWrapper: css`
      padding: 16px;
      .rdp-today:not(.rdp-selected) .rdp-day_button {
        color: rgba(4, 135, 230, 1);
      }
      .rdp-range_start .rdp-day_button,
      .rdp-range_end .rdp-day_button {
        background-color: #0487e6;
        border: none;
      }
      .rdp-chevron {
        fill: #0487e6;
      }
    `,
  };
};
